/** Plateformes supportées par le packaging siteAppliSFoncier (BL-0453). */
export type U3141SiteAppliPlatform = "macos-arm64" | "win-x64";

export interface U3141SiteAppliArtifact {
  platform: string;
  url: string;
  filename?: string;
  sha256?: string;
  sizeBytes?: number;
}

export interface U3141SiteAppliVersionManifest {
  schemaVersion?: number;
  app?: string;
  version?: string;
  artifacts?: U3141SiteAppliArtifact[];
}

export type U3141SiteAppliResolveResult =
  | { ok: true; artifact: U3141SiteAppliArtifact; platform: U3141SiteAppliPlatform }
  | { ok: false; reason: "invalid_manifest" | "platform_missing" | "unknown_platform" };

/**
 * Détecte la plateforme cible à partir du user-agent navigateur.
 * Retourne null si OS non supporté en v1 (ex. Linux) → UI propose les deux liens.
 */
export function u3141DetectSiteAppliPlatform(userAgent: string = typeof navigator !== "undefined" ? navigator.userAgent : ""): U3141SiteAppliPlatform | null {
  const ua = userAgent.toLowerCase();
  if (ua.includes("mac") || ua.includes("darwin")) return "macos-arm64";
  if (ua.includes("win")) return "win-x64";
  return null;
}

/**
 * Sélectionne l'artefact ZIP correspondant à la plateforme dans le manifeste version.json.
 */
export function u3141ResolveSiteAppliArtifact(
  versionJson: unknown,
  platform: U3141SiteAppliPlatform,
): U3141SiteAppliResolveResult {
  if (!versionJson || typeof versionJson !== "object") {
    return { ok: false, reason: "invalid_manifest" };
  }
  const manifest = versionJson as U3141SiteAppliVersionManifest;
  if (!Array.isArray(manifest.artifacts) || manifest.artifacts.length === 0) {
    return { ok: false, reason: "invalid_manifest" };
  }
  const artifact = manifest.artifacts.find((a) => a && a.platform === platform && typeof a.url === "string" && a.url.length > 0);
  if (!artifact) {
    return { ok: false, reason: "platform_missing" };
  }
  return { ok: true, artifact, platform };
}

/** Liste les artefacts macOS / Windows valides pour un dialogue de choix (OS inconnu). */
export function u3141ListSiteAppliDownloadChoices(versionJson: unknown): {
  macos?: U3141SiteAppliArtifact;
  windows?: U3141SiteAppliArtifact;
} {
  if (!versionJson || typeof versionJson !== "object") return {};
  const manifest = versionJson as U3141SiteAppliVersionManifest;
  if (!Array.isArray(manifest.artifacts)) return {};
  const macos = manifest.artifacts.find((a) => a?.platform === "macos-arm64" && typeof a.url === "string" && a.url.length > 0);
  const windows = manifest.artifacts.find((a) => a?.platform === "win-x64" && typeof a.url === "string" && a.url.length > 0);
  return { macos, windows };
}
